// Services shown in the homepage Services section.
// To swap a placeholder image with a real Indoor Greens photo, just replace `image`.

export const SERVICES = [
  {
    id: "corporate-plant-rental",
    persona: "For Heads of Admin & HR",
    title: "Plant Rental for Corporates",
    tagline: "A greener workplace, without the operational overhead.",
    body:
      "We install, maintain and rotate premium indoor plants across your office on a simple monthly rental. Zero capex, zero replacement worries — just healthier air, calmer teams and interiors that quietly perform. Ideal for headquarters, boutique offices and campuses.",
    bullets: [
      "Curation, delivery and installation included",
      "Weekly on-site maintenance by trained horticulturists",
      "Any wilted plant replaced free of charge",
      "Flexible monthly contracts, no long lock-ins",
    ],
    cta_label: "Request a corporate proposal",
    cta_href: "/#contact",
    image:
      "https://images.unsplash.com/photo-1497215728101-856f4ea42174?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "design-partner",
    persona: "For Architects, Interior Designers & Homeowners",
    title: "Greenery Solutions Partner",
    tagline: "The horticultural chapter of your design vision.",
    body:
      "From concept boards to installation day, we collaborate with studios and homeowners to specify, source and install the right plants in the right places — and stay on to care for them. Think of us as the botanical consultants embedded in your project team.",
    bullets: [
      "Species selection matched to light, ceiling height and mood",
      "Sourcing of specimen trees, bonsai and rare planters",
      "Site installation aligned with your project timeline",
      "Post-handover maintenance so nothing declines after opening",
    ],
    cta_label: "Partner with our studio",
    cta_href: "/#contact",
    image:
      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    id: "lawn-garden-maintenance",
    persona: "For private residences, farmhouses & estates",
    title: "Lawn & Garden Maintenance",
    tagline: "Grounds that stay pristine, season after season.",
    body:
      "A dedicated horticultural team on a fortnightly or weekly rhythm — mowing, pruning, seasonal planting, pest care, feeding and irrigation checks. Everything documented and reported, so your garden looks the way it did the day it was designed.",
    bullets: [
      "Weekly or fortnightly programmes",
      "Certified horticulturists and trained gardeners",
      "Seasonal planting, pruning and pest care",
      "Irrigation audits and gentle fertilising",
    ],
    cta_label: "Enrol my estate",
    cta_href: "/#contact",
    image:
      "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];
